import { toast } from 'react-hot-toast'

export const useToast = () => {
  const showSuccess = (message: string, duration?: number) => {
    return toast.success(message, {
      duration: duration || 4000,
      style: {
        background: '#10b981',
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
      },
    })
  }

  const showError = (message: string, duration?: number) => {
    // Clear existing error toasts to prevent spam
    toast.dismiss()
    
    return toast.error(message, {
      duration: duration || 5000, // Shorter duration
      style: {
        background: '#ef4444',
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
        maxWidth: '400px',
      },
      // Make error toasts dismissible
      id: `error-${Date.now()}`,
    })
  }

  const showInfo = (message: string, duration?: number) => {
    return toast(message, {
      duration: duration || 5000,
      style: {
        background: '#3b82f6',
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
      },
    })
  }

  const showWarning = (message: string, duration?: number) => {
    return toast(message, {
      duration: duration || 5000,
      style: {
        background: '#f59e0b',
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
      },
      icon: '⚠️',
    })
  }

  const dismiss = (toastId: string) => {
    toast.dismiss(toastId)
  }

  const dismissAll = () => {
    toast.dismiss()
  }

  const showAuthError = (message: string = 'Authentication failed. Please log in again.') => {
    // Clear all existing toasts first
    toast.dismiss()
    
    return toast.error(message, {
      duration: 10000, // Longer duration for auth errors
      style: {
        background: '#dc2626',
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
        maxWidth: '400px',
        border: '2px solid #fca5a5',
      },
      id: `auth-error-${Date.now()}`,
    })
  }

  const clearAllToasts = () => {
    toast.dismiss()
  }

  return {
    showSuccess,
    showError,
    showInfo,
    showWarning,
    showAuthError,
    dismiss,
    dismissAll,
    clearAllToasts,
  }
}
